import FormView from "./FormView";

export default FormView;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/index.js